import { StaffAccountDetailsTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const StaffAccountDetailsTrackingSchema: Record<
  StaffAccountDetailsTrackingPoint,
  string
> = {
  [StaffAccountDetailsTrackingPoint.PageView]: '',
  [StaffAccountDetailsTrackingPoint.ChangeStaffPassword]: '',
};

export const getStaffAccountDetailsPageTypeAndSchema = (
  trackingPoint: StaffAccountDetailsTrackingPoint
) => {
  return {
    page_type: PageType.StaffAccountDetailsPage,
    schema: StaffAccountDetailsTrackingSchema[trackingPoint],
  };
};
